"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mdLineNumber = void 0;
var injectLineNumbers = function (tokens, idx, options, env, slf) {
    var line;
    if (tokens[idx] && tokens[idx].map && tokens[idx].level === 0) {
        line = tokens[idx].map[0];
        tokens[idx].attrJoin('class', 'line');
        tokens[idx].attrSet('data-line', String(line));
    }
    return slf.renderToken(tokens, idx, options);
};
exports.mdLineNumber = function (md) {
    md.renderer.rules.paragraph_open = md.renderer.rules.heading_open = injectLineNumbers;
    return md;
};
